import { apiFetch } from './api';

export type TipoAtendimento = 'Consulta' | 'Exame' | 'Cirurgia' | 'Retorno' | 'Telemedicina';

export type Atendimento = {
  id: string;
  pacienteId: string;
  medicoResponsavelId: string | null;
  cirurgiaId: string | null;
  dataAtendimento: string;
  tipo: TipoAtendimento;
  descricao: string;
  diagnostico: string | null;
  conduta: string | null;
  criadoEm: string;
};

export type CreateAtendimentoPayload = {
  pacienteId: string;
  medicoResponsavelId?: string;
  cirurgiaId?: string;
  dataAtendimento?: string;
  tipo: TipoAtendimento;
  descricao: string;
  diagnostico?: string;
  conduta?: string;
};

export const listAtendimentos = (pacienteId?: string) =>
  apiFetch<Atendimento[]>(`/atendimentos${pacienteId ? `?pacienteId=${pacienteId}` : ''}`);

export const getAtendimento = (id: string) => apiFetch<Atendimento>(`/atendimentos/${id}`);

export const createAtendimento = (data: CreateAtendimentoPayload) =>
  apiFetch<Atendimento>('/atendimentos', { method: 'POST', body: JSON.stringify(data) });
